import { render, staticRenderFns } from "./cNewpopup.vue?vue&type=template&id=48cb2461&scoped=true"
import script from "./cNewpopup.vue?vue&type=script&lang=js"
export * from "./cNewpopup.vue?vue&type=script&lang=js"
import style0 from "./cNewpopup.vue?vue&type=style&index=0&id=48cb2461&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb2461",
  null
  
)

export default component.exports